import React from "react";
import SmartSuggestInput from "@/components/SmartSuggestInput";
import { Input, Btn } from "@/components/UI";
import { Trash2, Plus } from "lucide-react";
import { calcLine, freeFromMf, PRICE_FIELD } from "@/lib/sales";
import { fmtNum } from "@/lib/products";

export const emptyLine = () => ({ key: Math.random().toString(36).slice(2), product_id: "", product_name: "", qty: "", mf_ratio: "", free_qty: "", free_manual: false, unit_price: "", list_price: null, discount_pct: 0, vat_pct: "" });

function LineRow({ ln, i, products, priceGroup, vatDefault, onChange, onRemove }) {
  const set = (patch) => {
    const next = { ...ln, ...patch };
    if (!next.free_manual && ("qty" in patch || "mf_ratio" in patch)) next.free_qty = freeFromMf(next.qty, next.mf_ratio) || "";
    onChange(next);
  };
  const pick = ({ value, item }) => {
    if (!item) return onChange({ ...ln, product_name: value, product_id: "" });
    const price = Number(item[PRICE_FIELD[priceGroup]] || 0);
    onChange({ ...ln, product_id: item.id, product_name: item.name, unit_price: price, list_price: price, vat_pct: ln.vat_pct === "" ? vatDefault : ln.vat_pct });
  };
  const c = calcLine(ln);
  const t = (k) => `so-line-${k}-${i}`;
  return (
    <tr className="border-b border-slate-100 align-top" data-testid={`so-line-${i}`}>
      <td className="p-1.5 w-64"><SmartSuggestInput value={ln.product_name} items={products} displayField="name" secondaryField="code" searchAccessor={(p) => [p.code]} placeholder="Ürün ara…" onChange={pick} data-testid={t("product")} /></td>
      <td className="p-1.5 w-20"><Input type="number" min="0" value={ln.qty} onChange={(e) => set({ qty: e.target.value })} data-testid={t("qty")} /></td>
      <td className="p-1.5 w-20"><Input placeholder="6/1" value={ln.mf_ratio} onChange={(e) => set({ mf_ratio: e.target.value })} data-testid={t("mf")} /></td>
      <td className="p-1.5 w-20"><Input type="number" min="0" value={ln.free_qty} onChange={(e) => onChange({ ...ln, free_qty: e.target.value, free_manual: e.target.value !== "" })} data-testid={t("free")} /></td>
      <td className="p-1.5 w-28">
        <Input type="number" min="0" step="0.01" value={ln.unit_price} onChange={(e) => onChange({ ...ln, unit_price: e.target.value })} data-testid={t("price")} />
        {ln.list_price !== null && Number(ln.unit_price) !== ln.list_price && <div className="text-[10px] text-amber-700 mt-0.5" data-testid={t("price-override")}>Liste: {fmtNum(ln.list_price)}</div>}
      </td>
      <td className="p-1.5 w-20"><Input type="number" min="0" max="100" value={ln.discount_pct} onChange={(e) => onChange({ ...ln, discount_pct: e.target.value })} data-testid={t("discount")} /></td>
      <td className="p-1.5 w-20"><Input type="number" min="0" max="100" value={ln.vat_pct} onChange={(e) => onChange({ ...ln, vat_pct: e.target.value })} data-testid={t("vat")} /></td>
      <td className="p-1.5 w-32 text-right text-sm pt-3">
        <b data-testid={t("net")}>{fmtNum(c.net)}</b>
        <div className="text-[10px] text-slate-500">Fiziksel: {c.physical}</div>
      </td>
      <td className="p-1.5 pt-2.5"><button onClick={onRemove} className="text-rose-500 hover:text-rose-700" data-testid={t("remove")}><Trash2 size={14} /></button></td>
    </tr>
  );
}

export function OrderLinesEditor({ lines, setLines, products, priceGroup, vatDefault }) {
  const update = (i, ln) => setLines(lines.map((x, j) => (j === i ? ln : x)));
  return (
    <div className="overflow-x-auto" data-testid="so-lines-editor">
      <table className="w-full text-sm">
        <thead><tr className="text-[10px] uppercase tracking-wider text-slate-500 text-left">
          {["Ürün", "Sipariş Adedi", "MF Oranı", "Bedelsiz", "Birim Fiyat", "İsk. %", "KDV %", "Satır Net", ""].map((h) => <th key={h} className="p-1.5 font-semibold">{h}</th>)}
        </tr></thead>
        <tbody>
          {lines.map((ln, i) => (
            <LineRow key={ln.key} ln={ln} i={i} products={products} priceGroup={priceGroup} vatDefault={vatDefault}
              onChange={(n) => update(i, n)} onRemove={() => setLines(lines.filter((_, j) => j !== i))} />
          ))}
        </tbody>
      </table>
      <Btn size="sm" variant="secondary" className="mt-2" onClick={() => setLines([...lines, emptyLine()])} data-testid="so-add-line"><Plus size={12} /> Satır Ekle</Btn>
    </div>
  );
}
